module.exports = __webpack_public_path__ + "static/media/houdini-logo@2x.f0593043.png";